import React, { useEffect, useState } from 'react';
import '../../styles/loginPage.css';
import '../../styles/register.css';
import { notify } from '../toast';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useNavigate, useParams } from 'react-router-dom';

const HIERARCHY_LEVELS = [
    { value: 'village_cluster', label: 'Village Cluster' },
    { value: 'mandal_officer', label: 'Mandal Officer' },
    { value: 'district_officer', label: 'District Officer' },
];

const AdminEmployeeEdit = () => {

    const { id } = useParams();

    const [name, setName] = useState('');
    const [gender, setGender] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [parent, setParent] = useState('');
    const [address, setAddress] = useState('');
    const [educationQualification, setEducationQualification] = useState('');
    const [aadhaar, setAadhaar] = useState('');
    const [pan, setPan] = useState('');
    const [bank, setBank] = useState('');
    const [ifsc, setIfsc] = useState('');
    const [hierarchyLevel, setHierarchyLevel] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        const fetchEmployee = async () => {
            try {

                const response = await axiosPrivate.get(`/admin/getEmployeeDetails/${id}`);

                const data = response?.data
                setName(data?.name);
                setGender(data?.gender);
                setEmail(data?.email);
                setMobile(data?.mobile.toString());
                setParent(data?.parent);
                setAddress(data?.address);
                setEducationQualification(data?.educationQualification);
                setAadhaar(data?.aadhaar);
                setPan(data?.pan);
                setBank(data?.bank);
                setIfsc(data?.ifsc);
                setHierarchyLevel(data?.role);

            } catch (err) {
                notify('failed', err?.response?.data?.message);
            }
        }
        fetchEmployee();

        // eslint-disable-next-line
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!validateMobile(mobile) || mobile.length !== 10) {
            return setError('Invalid mobile number');
        } else {
            try {
                setLoading(true);
                const response = await axiosPrivate.put('/admin/putEmployee', {
                    employeeId: id,
                    name,
                    gender,
                    email,
                    mobile,
                    parent,
                    address,
                    educationQualification,
                    aadhaar,
                    bank,
                    ifsc,
                    pan,
                    role: hierarchyLevel
                });
                const res = response?.data;
                notify('success', res?.success);

                navigate('/');
            } catch (err) {
                const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
                notify('failed', errorMessage)
            }
            finally {
                setLoading(false);
            }
        }
    };

    const validateMobile = (mobile) => {
        const re = /^[0-9]{10}$/;
        return re.test(mobile);
    };

    return (
        <div className='formContainer'>
            <div className='formWrapper'>
                <h2 className='formTitle'>Edit Employee</h2>
                {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
                <form onSubmit={handleSubmit}>

                    <div className='formRow'>
                        <div className='formGroup'>
                            <div className='formGroup'>
                                <span className='formLabel'>Name</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    autoFocus
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Mobile</span>
                                <input
                                    className='formInput'
                                    type="tel"
                                    value={mobile}
                                    onChange={(event) => setMobile(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Gender</span>
                                <select
                                    className="formInput"
                                    name='gender'
                                    value={gender}
                                    onChange={(event) => setGender(event.target.value)}
                                    required
                                >
                                    <option value="">select</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                </select>
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Parent</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={parent}
                                    onChange={(event) => setParent(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Education qualification</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={educationQualification}
                                    onChange={(event) => setEducationQualification(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Address</span>
                                <input
                                    className='formInput'
                                    value={address}
                                    type="text"
                                    onChange={(event) => setAddress(event.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className='formGroup'>
                            <div className='formGroup'>
                                <span className='formLabel'>Email</span>
                                <input
                                    className='formInput'
                                    type="email"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Aadhaar</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={aadhaar}
                                    onChange={(event) => setAadhaar(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>IFSC</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={ifsc}
                                    onChange={(event) => setIfsc(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Pan</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={pan}
                                    onChange={(event) => setPan(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Bank account number</span>
                                <input
                                    className='formInput'
                                    type="text"
                                    value={bank}
                                    onChange={(event) => setBank(event.target.value)}
                                    required
                                />
                            </div>
                            <div className='formGroup'>
                                <span className='formLabel'>Hierarchy level</span>
                                <select
                                    className="formInput"
                                    name='hierarchy'
                                    value={hierarchyLevel}
                                    onChange={(event) => setHierarchyLevel(event.target.value)}
                                    required
                                >
                                    {HIERARCHY_LEVELS.map(h => <option value={h.value}>{h.label}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    <button className='submitButton' type="submit" disabled={loading}>{loading ? <span className='spinner' /> : 'Edit'}</button>

                </form>
            </div>
        </div>
    );
}

export default AdminEmployeeEdit;